import React from 'react';
import { Link } from 'react-router-dom';
import { useProgress } from '../hooks/useProgress';
import courseData from '../data/courseData';

const Header = () => {
  const { calculateOverallProgress } = useProgress();
  const progressPercentage = calculateOverallProgress(courseData.length);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <h1>Ink Drawing for Beginners</h1>
        </Link>
        <div className="progress-container">
          <div className="progress-text">Course Progress: {progressPercentage}%</div>
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
